import { $api } from '../y/api';
import { makeDataStore } from '../y/data-store';
import { $http } from '../y/http';
import { YLanguage } from '../y/i18n';
import { YId, YTimeString } from '../y/types';
import { CEventId } from './c-event';
import { CProducerId } from './c-producer';

export interface VSubtitle {
    language: YLanguage;
}

export interface VRendition {
    id: YId;
    bandwidth: number;
    frame_rate: number;
    width: number;
    height: number;
}

export type VVideoStatus = 'created' | 'playable' | 'complete';

export interface VVideo {
    id: YId;
    name: string;
    status: VVideoStatus;
    duration: number;
    created_at: YTimeString;

    producer_id?: CProducerId;
    event_id?: CEventId;
    master_url: string;

    renditions: VRendition[];
    subtitles: VSubtitle[];
}

export const v_videos = makeDataStore('v/videos', 'v/video', (m: VVideo) => m, Object.assign);

export function vVideoUploadFile(name: string, file: File, progress?: (p: number) => void) {
    const url_base = '/service/media/v1/video_upload';

    return $http.POST(url_base, file, { aux: { name: name }, up_progress: progress }).catch($api.errorHandler);
}

// export function createStream(value: any)
// {
//     return $http.POST<TLStream>('/api/v1/stream', value).catch($api.errorHandler);
// }

// export function createVOD(name: string, producer: YId | undefined, origin: string)
// {
//     return $http.POST<TLVOD>('/api/v1/vod', {name: name, producer: $id.maybeIdToObjectId(producer), origin: origin}).catch($api.errorHandler);
// }

// export function reserveStream(id: YId)
// {
//     return $http.POST<TLStream>('/api/v1/stream/'+id+'/reserve').then(streams.register, $api.errorHandler);
// }

// export function launchStream(id: YId)
// {
//     return $http.POST<TLStream>('/api/v1/stream/'+id+'/launch').then(streams.register, $api.errorHandler);
// }

// export function scheduleLaunchStream(id: YId, when: YTime)
// {
//     return $http.POST<TLStream>('/api/v1/stream/'+id+'/schedule_launch', { when: when }).then(streams.register, $api.errorHandler);
// }

// export function stopStream(id: YId)
// {
//     return $http.POST<TLStream>('/api/v1/stream/'+id+'/stop').then(streams.register, $api.errorHandler);
// }

// export function endStream(id: YId)
// {
//     return $http.POST<TLStream>('/api/v1/stream/'+id+'/end').then(streams.register, $api.errorHandler);
// }

// export function addVODSubtitles(vod_id: YId, lang: string, file: File)
// {
//     return $http.POST<TLVOD>('/api/v1/vod/' + vod_id + '/subtitles', file,
//                              { aux: { lang: lang, filename: file.name, type: file.type }}).catch($api.errorHandler);
// }

// export function removeVODSubtitles(vod_id: YId, id: YId)
// {
//     return $http.DELETE<TLVOD>('/api/v1/vod/' + vod_id + '/subtitle/' + id).catch($api.errorHandler);
// }
